module.exports = __webpack_public_path__ + "img/MTN.71572dd3.jpg";